var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.closeAutocompleteList,
          expression: "closeAutocompleteList",
        },
      ],
      staticClass: "alpheios-input-group",
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.valueText,
            expression: "valueText",
          },
        ],
        ref: _vm.id,
        staticClass: "alpheios-input",
        class: { "alpheios-rtl": _vm.directionRtl },
        attrs: {
          autocapitalize: "off",
          autocorrect: "off",
          autocomplete: "off",
          type: "text",
          id: _vm.id,
          lang: _vm.lang,
        },
        domProps: { value: _vm.valueText },
        on: {
          keyup: _vm.checkLookupKeyPress,
          paste: _vm.onPaste,
          click: _vm.closeAutocompleteList,
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.valueText = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.currentEnableLogeionAutoComplete && _vm.words.length > 0,
              expression:
                "currentEnableLogeionAutoComplete && words.length > 0",
            },
          ],
          staticClass: "alpheios-input-autocomplete",
        },
        _vm._l(_vm.words, function (word, index) {
          return _c(
            "span",
            {
              key: index,
              staticClass: "alpheios-input-autocomplete-item",
              on: {
                click: function ($event) {
                  return _vm.selectWordFromAutoComplete(word)
                },
              },
            },
            [_vm._v(_vm._s(word))]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }